// Honeycomb PGM Code Mapping — authoritative source of truth.
// Generated from Veneta-supplied catalogue (212 colours).
// Any new colour MUST be confirmed with Veneta and added here before introduction.
//
// Key format: `${material}|${colour}` (both lowercase, trimmed).
// Value: PGM code per XML Field Mapping spec.
//   DF  = Signature (Blockout + Light Filter)
//   RD  = other Blockout
//   WSP = One Tone Light Filter
//   LF  = other Light Filter
//   SH  = Sheer

export const HONEYCOMB_PGM_CODE_MAP: Record<string, string> = {
  // Blockout (95)
  'blockout|annapolis gray': 'RD',
  'blockout|autumn gold': 'RD',
  'blockout|black ink': 'RD',
  'blockout|black olive': 'RD',
  'blockout|blue flower': 'RD',
  'blockout|brie': 'RD',
  'blockout|brilliant white': 'RD',
  'blockout|cabin': 'RD',
  'blockout|catalina blue': 'RD',
  'blockout|champagne': 'RD',
  'blockout|classic silver': 'RD',
  'blockout|coffee beans': 'RD',
  'blockout|cotton cloud': 'RD',
  'blockout|daisy': 'RD',
  'blockout|desert': 'RD',
  'blockout|dusk': 'RD',
  'blockout|ecru': 'RD',
  'blockout|eggplant': 'RD',
  'blockout|fernwood': 'RD',
  'blockout|flax': 'RD',
  'blockout|fog green': 'RD',
  'blockout|foggy morning': 'RD',
  'blockout|french silver': 'RD',
  'blockout|gardenia': 'RD',
  'blockout|glacier white': 'RD',
  'blockout|indigo': 'RD',
  'blockout|infinity': 'RD',
  'blockout|iron mountain': 'RD',
  'blockout|lakeside': 'RD',
  'blockout|larkspur': 'RD',
  'blockout|latte': 'RD',
  'blockout|lead gray': 'RD',
  'blockout|meadows': 'RD',
  'blockout|mineral': 'RD',
  'blockout|morning blush': 'RD',
  'blockout|morning mist': 'RD',
  'blockout|mulberry': 'RD',
  'blockout|natural tan': 'RD',
  'blockout|new camel': 'RD',
  'blockout|ocean air': 'RD',
  'blockout|orion gray': 'RD',
  'blockout|pacific cove': 'RD',
  'blockout|pale oak': 'RD',
  'blockout|pashmina': 'RD',
  'blockout|pebble': 'RD',
  'blockout|power gray': 'RD',
  'blockout|primrose': 'RD',
  'blockout|provence cream': 'RD',
  'blockout|reflections': 'RD',
  'blockout|river rock': 'RD',
  'blockout|roasted pumpkin': 'RD',
  'blockout|rue bourbon': 'RD',
  'blockout|sand': 'RD',
  'blockout|seal gray': 'RD',
  'blockout|seaside blue': 'RD',
  'blockout|signature azure blue': 'DF',
  'blockout|signature canvas': 'DF',
  'blockout|signature dawn': 'DF',
  'blockout|signature fog': 'DF',
  'blockout|signature fresh brew': 'DF',
  'blockout|signature magnetic gray': 'DF',
  'blockout|signature misty coast': 'DF',
  'blockout|signature shady lane': 'DF',
  'blockout|signature silver fern': 'DF',
  'blockout|signature soft black': 'DF',
  'blockout|signature sterling': 'DF',
  'blockout|signature storm cloud': 'DF',
  'blockout|signature stormy gray': 'DF',
  'blockout|signature tawny': 'DF',
  'blockout|signature titanium': 'DF',
  'blockout|signature toasted walnut': 'DF',
  'blockout|signature toffee': 'DF',
  'blockout|signature weathered earth': 'DF',
  'blockout|signature white dawn': 'DF',
  'blockout|signature winter solstice': 'DF',
  'blockout|silver satin': 'RD',
  'blockout|sky gray': 'RD',
  'blockout|slate': 'RD',
  'blockout|smokey blue': 'RD',
  'blockout|soft stone': 'RD',
  'blockout|spring sky': 'RD',
  'blockout|steel gray': 'RD',
  'blockout|storm cloud': 'RD',
  'blockout|tamarind': 'RD',
  'blockout|terra': 'RD',
  'blockout|topaz': 'RD',
  'blockout|vanilla milkshake': 'RD',
  'blockout|wheat': 'RD',
  'blockout|whipped mocha': 'RD',
  'blockout|whisper white': 'RD',
  'blockout|white cream': 'RD',
  'blockout|white rain': 'RD',
  'blockout|white water': 'RD',
  'blockout|winter solstice': 'RD',
  'blockout|yellow bliss': 'RD',

  // Light Filter (110)
  'light filter|agave': 'LF',
  'light filter|annapolis gray': 'LF',
  'light filter|autumn gold': 'LF',
  'light filter|bamboo': 'LF',
  'light filter|birch': 'LF',
  'light filter|black olive': 'LF',
  'light filter|blue flower': 'LF',
  'light filter|bright white': 'LF',
  'light filter|brilliant white': 'LF',
  'light filter|cabin': 'LF',
  'light filter|calm one tone': 'WSP',
  'light filter|cashmere one tone': 'WSP',
  'light filter|catalina blue': 'LF',
  'light filter|chantilly lace one tone': 'WSP',
  'light filter|chestnut': 'LF',
  'light filter|chocolate': 'LF',
  'light filter|classic silver': 'LF',
  'light filter|clover': 'LF',
  'light filter|coffee beans': 'LF',
  'light filter|coral': 'LF',
  'light filter|cottage white': 'LF',
  'light filter|cotton cloud': 'LF',
  'light filter|creamy': 'LF',
  'light filter|crystal': 'LF',
  'light filter|daisy': 'LF',
  'light filter|dove': 'LF',
  'light filter|eggplant': 'LF',
  'light filter|espresso': 'LF',
  'light filter|fern': 'LF',
  'light filter|fernwood': 'LF',
  'light filter|flax': 'LF',
  'light filter|flint': 'LF',
  'light filter|four leaf clover': 'LF',
  'light filter|french silver': 'LF',
  'light filter|frost': 'LF',
  'light filter|gardenia': 'LF',
  'light filter|ginger spice': 'LF',
  'light filter|graphite': 'LF',
  'light filter|gray violet': 'LF',
  'light filter|harbor': 'LF',
  'light filter|haze one tone': 'WSP',
  'light filter|heather': 'LF',
  'light filter|horizon one tone': 'WSP',
  'light filter|indigo': 'LF',
  'light filter|iron mountain': 'LF',
  'light filter|ivory': 'LF',
  'light filter|jet black': 'LF',
  'light filter|lakeside': 'LF',
  'light filter|maize': 'LF',
  'light filter|marigold': 'LF',
  'light filter|marshmallow': 'LF',
  'light filter|meadows': 'LF',
  'light filter|mica': 'LF',
  'light filter|mint': 'LF',
  'light filter|morning blush': 'LF',
  'light filter|morning mist': 'LF',
  'light filter|mulberry': 'LF',
  'light filter|natural': 'LF',
  'light filter|natural cream': 'LF',
  'light filter|natural tan': 'LF',
  'light filter|new camel': 'LF',
  'light filter|ocean air': 'LF',
  'light filter|orion gray': 'LF',
  'light filter|oxford blue': 'LF',
  'light filter|pacific cove': 'LF',
  'light filter|pale oak': 'LF',
  'light filter|pashmina': 'LF',
  'light filter|pebble': 'LF',
  'light filter|petal': 'LF',
  'light filter|petal pink': 'LF',
  'light filter|plum purple': 'LF',
  'light filter|provence cream': 'LF',
  'light filter|reflections': 'LF',
  'light filter|river rock': 'LF',
  'light filter|roasted pumpkin': 'LF',
  'light filter|rose': 'LF',
  'light filter|rue bourbon': 'LF',
  'light filter|rustic beige one tone': 'WSP',
  'light filter|sahara': 'LF',
  'light filter|sand': 'LF',
  'light filter|seal gray': 'LF',
  'light filter|seaside blue': 'LF',
  'light filter|shale': 'LF',
  'light filter|signature canvas': 'DF',
  'light filter|signature fresh brew': 'DF',
  'light filter|signature quarry': 'DF',
  'light filter|signature silver coin': 'DF',
  'light filter|signature smokey violet': 'DF',
  'light filter|signature sterling': 'DF',
  'light filter|signature urban gray': 'DF',
  'light filter|signature winter solstice': 'DF',
  'light filter|silver satin': 'LF',
  'light filter|sky': 'LF',
  'light filter|slate': 'LF',
  'light filter|smokey blue': 'LF',
  'light filter|soft stone': 'LF',
  'light filter|soft taupe': 'LF',
  'light filter|spearmint': 'LF',
  'light filter|spring sky': 'LF',
  'light filter|tangerine': 'LF',
  'light filter|terra': 'LF',
  'light filter|topaz': 'LF',
  'light filter|vanilla ice cream one tone': 'WSP',
  'light filter|wheat': 'LF',
  'light filter|whipped mocha': 'LF',
  'light filter|white cream': 'LF',
  'light filter|white rain': 'LF',
  'light filter|white sand one tone': 'WSP',
  'light filter|willow': 'LF',
  'light filter|yellow bliss': 'LF',

  // Sheer (7)
  'sheer|chardonnay': 'SH',
  'sheer|cloud white': 'SH',
  'sheer|cloudy chiffon': 'SH',
  'sheer|jersey cream': 'SH',
  'sheer|nightfall': 'SH',
  'sheer|seapearl': 'SH',
  'sheer|sierra hills': 'SH',
};

export const lookupHoneycombPgmCode = (
  material?: string,
  colour?: string,
): string => {
  if (!material) return '';
  const mat = material.trim().toLowerCase();
  const rawName = colour?.includes(':')
    ? colour.split(':').slice(1).join(':')
    : colour ?? '';
  const name = rawName.trim().toLowerCase();
  const key = `${mat}|${name}`;
  const code = HONEYCOMB_PGM_CODE_MAP[key];
  if (code !== undefined) return code;
  // Not in authoritative map. Flag for client confirmation, return empty per spec.
  console.warn(
    `[Honeycomb PGM] Unmapped fabric: material="${material}", colour="${rawName.trim()}". Confirm mapping with Veneta and add to HONEYCOMB_PGM_CODE_MAP before shipping.`,
  );
  return '';
};
